export const PortOfEntryInput = [
    {name:'Visakhapatnam',value:1},{name : 'Chennai ',value:2},{name : 'Vijayawada',value:3},{name : 'Mumbai',value:4},{name : 'Kochi',value:5}
]
  

